import(/* webpackMode: "eager" */ "/app/components/Collection/Collection.tsx")